import moment from 'moment'
import { API_URL } from '../constants'
import { AdminFundDepositDto, DepositDto, SwapDto } from '../types/coreApi-types'
import downloadFile from './downloadFile'

export default async function downloadSwapInvoice(
  swap: SwapDto,
  sessionToken: string,
  customUrl?: string
) {
  const url = customUrl || `${API_URL}/swaps/${swap.id}/invoice`
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${sessionToken}` },
  })

  const bankUniqueIdOrSwapId = swap.deposit?.bankDepositUniqueId ?? swap.id
  const createdAtFormatted = moment(swap.createdAt).format(
    'YYYY-MM-DD-HH-mm-ss'
  )
  const fileSafeName = swap.user.name.replace(/\s+/g, '-')
  const prefix = customUrl ? 'Legacy_Swap' : 'Swap'
  const fileTitle = `${prefix}_${createdAtFormatted}_${fileSafeName}_${bankUniqueIdOrSwapId}`

  const blob = await res.blob()
  const newBlob = new Blob([blob])

  const blobUrl = window.URL.createObjectURL(newBlob)

  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute('download', `${fileTitle}.pdf`)
  document.body.appendChild(link)
  link.click()
  link.parentNode!.removeChild(link)

  // clean up Url
  window.URL.revokeObjectURL(blobUrl)
}

export async function downloadAdminSwapInvoice(
  swapId: string,
  sessionToken: string
) {
  const url = `${API_URL}/swaps/admin/${swapId}/invoice`
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${sessionToken}` },
  })

  if (!res.ok) {
    throw new Error(`Failed to download invoice: ${res.statusText}`)
  }

  const blob = await res.blob()

  // Extract filename from Content-Disposition header if available, otherwise use swapId
  const contentDisposition = res.headers.get('Content-Disposition')
  let fileName = `Admin_Swap_${swapId}.pdf`

  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
    if (fileNameMatch && fileNameMatch[1]) {
      fileName = fileNameMatch[1]
    }
  }

  // Use the existing downloadFile utility
  downloadFile(undefined, fileName.replace('.pdf', ''), 'pdf', blob)
}

export async function downloadFundDepositInvoice(
  deposit: DepositDto & { user?: { name?: string } },
  sessionToken: string
) {
  const url = `${API_URL}/fund/deposits/${deposit.id}/invoice`
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${sessionToken}` },
  })

  if (!res.ok) {
    throw new Error(`Failed to download fund deposit invoice: ${res.statusText}`)
  }

  const bankUniqueIdOrId = deposit.bankDepositUniqueId || deposit.id
  const createdAtFormatted = moment(deposit.createdAt).format(
    'YYYY-MM-DD-HH-mm-ss'
  )
  const investorName = (deposit as AdminFundDepositDto).user?.name
  const fileSafeName = investorName ? `_${investorName.replace(/\s+/g, '-')}` : ''
  const fileTitle = `Fund_Deposit_${createdAtFormatted}${fileSafeName}_${bankUniqueIdOrId}`

  const blob = await res.blob()
  const newBlob = new Blob([blob])
  const blobUrl = window.URL.createObjectURL(newBlob)

  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute('download', `${fileTitle}.pdf`)
  document.body.appendChild(link)
  link.click()
  link.parentNode!.removeChild(link)

  window.URL.revokeObjectURL(blobUrl)
}
